// inactivityConfig.js - Configuration for inactivity timer

export const INACTIVITY_CONFIG = {
  // Default timeout in minutes (reduced for testing)
  DEFAULT_TIMEOUT_MINUTES: 2,
  
  // Admin timeout (can be longer for admin users)
  ADMIN_TIMEOUT_MINUTES: 3,
  
  // Warning time before logout (in minutes)
  WARNING_TIME_MINUTES: 0.5,
  
  // Whether to show console logs for debugging
  DEBUG_LOGS: true,
  
  // Events that reset the timer
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'focus'
  ],
  
  // Custom messages
  MESSAGES: {
    WARNING: 'You will be logged out in 2 minutes due to inactivity.\n\nClick "OK" to stay logged in, or "Cancel" to logout now.',
    LOGOUT_ALERT: 'You have been logged out due to inactivity for security reasons.',
    LOGIN_MESSAGE: 'You have been logged out due to inactivity for security reasons. Please log in again.'
  }
};

export default INACTIVITY_CONFIG;
